import React from 'react';
import {
  Button, Input, InputNumber, Segmented, Switch, Tag, Typography,
} from 'antd';
import { UndoOutlined } from '@ant-design/icons';
import SoundStringBuilder from './SoundString/SoundStringBuilder';
import { isValidJson } from './paramsMeta';

function formatDefault(meta, value) {
  if (meta.control === 'switch') return value === '1' ? 'вкл.' : 'выкл.';
  if (meta.control === 'json' || meta.control === 'sound') return '';
  if (!value) return '«пусто»';
  return meta.unit ? `${value} ${meta.unit}` : value;
}

function renderControl({
  meta, value, onChange, disabled, soundData, callNumbers,
}) {
  switch (meta.control) {
    case 'switch':
      return <Switch checked={value === '1'} disabled={disabled} onChange={(checked) => onChange(checked ? '1' : '0')} />;
    case 'number':
      return (
        <InputNumber
          min={meta.min ?? 0}
          precision={0}
          disabled={disabled}
          style={{ width: 130 }}
          addonAfter={meta.unit}
          value={value === '' ? null : Number(value)}
          onChange={(next) => onChange(next === null ? '0' : String(next))}
        />
      );
    case 'scale':
      return (
        <Segmented
          disabled={disabled}
          options={Array.from({ length: meta.max - meta.min + 1 }, (_, i) => meta.min + i)}
          value={Number(value)}
          onChange={(next) => onChange(String(next))}
        />
      );
    case 'json':
      return (
        <>
          <Input.TextArea
            autoSize={{ minRows: 3, maxRows: 12 }}
            disabled={disabled}
            status={isValidJson(value) ? '' : 'error'}
            style={{ fontFamily: 'monospace', fontSize: 12 }}
            value={value}
            onChange={(e) => onChange(e.target.value)}
          />
          {!isValidJson(value) && <Typography.Text type="danger">Некорректный JSON</Typography.Text>}
        </>
      );
    case 'sound':
      return (
        <SoundStringBuilder
          data={soundData}
          value={value}
          onChange={onChange}
          callNumbers={callNumbers}
          disabled={disabled}
        />
      );
    default:
      return (
        <Input disabled={disabled} style={{ width: 260 }} value={value} onChange={(e) => onChange(e.target.value)} />
      );
  }
}

function ParamRow({
  meta, value, defaultValue, onChange, disabled, soundData, first, callNumbers,
}) {
  const changed = value !== defaultValue;
  const fullWidth = meta.control === 'json' || meta.control === 'sound';
  const defaultText = formatDefault(meta, defaultValue);
  const control = renderControl({
    meta, value, onChange, disabled, soundData, callNumbers,
  });

  const label = (
    <div style={{ flex: 1, minWidth: 0 }}>
      <div>
        {meta.label}
        {changed && <Tag color="blue" style={{ marginLeft: 8 }}>изменено</Tag>}
      </div>
      {meta.hint && <Typography.Text type="secondary" style={{ fontSize: 12 }}>{meta.hint}</Typography.Text>}
      {changed && !disabled && (
        <div>
          <Button
            type="link"
            size="small"
            icon={<UndoOutlined />}
            style={{ padding: 0, height: 'auto' }}
            onClick={() => onChange(defaultValue)}
          >
            {defaultText ? `Вернуть базовое: ${defaultText}` : 'Вернуть базовое'}
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <div style={{
      padding: '10px 0 10px 10px',
      marginLeft: -13,
      borderLeft: `3px solid ${changed ? '#1677ff' : 'transparent'}`,
      borderTop: first ? 'none' : '1px solid #f0f0f0',
    }}
    >
      {fullWidth ? (
        <>
          {label}
          <div style={{ marginTop: 8 }}>{control}</div>
        </>
      ) : (
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          {label}
          {control}
        </div>
      )}
    </div>
  );
}

export default ParamRow;
